import { useMutation } from "react-query";
import { useSnackbar } from "notistack";
import { appendValues } from "../api-services/consumer";
import { useMyInfo } from "./user.hooks";

interface ConsumerRequestData {
  consumerName: string;
  consumerEmail: string;
  consumerPhone: string;
  brokerName: string;
  brokerEmail: string;
  brokerPhone: string;
}

export const useConsumerRequest = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { data: userInfo } = useMyInfo();
  return useMutation(
    (data: ConsumerRequestData) =>
      appendValues({ ...data, userId: userInfo?.id }),
    {
      onError: (error: any) => {
        enqueueSnackbar(
          error?.data?.message ||
            "Failed to submit access request. Please try again.",
          {
            variant: "error",
          }
        );
      },
    }
  );
};
